import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  {
    path: 'deeplTranslator',
    loadChildren: () => import('@features/deepl/deepl.module').then(m => m.DeeplModule)
  },
  {
    path: '**', redirectTo: 'deeplTranslator', pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
